import createVueComponent from '../createVueComponent';

const Terminal = createVueComponent('TerminalIcon', [
  ['polyline', { points: '4 17 10 11 4 5' }],
  ['line', { x1: '12', y1: '19', x2: '20', y2: '19' }],
]);

export default Terminal;
